import React, { FC } from "react"
import styled from "styled-components"

type BreadcrumbProps = {
  title: string
  isActive?: boolean
  onClick: () => void
}

const BreadcrumbLink = styled.a`
  cursor: pointer;
`

const Title = styled.span`
  font-size: 14px;
  line-height: 150%;
`

const ActiveTitle = styled(Title)`
  font-weight: 500;
`

const Breadcrumb: FC<BreadcrumbProps> = ({ title, isActive, onClick }) => {
  return (
    <BreadcrumbLink onClick={onClick}>
      {isActive ? (
        <ActiveTitle className={"black-80 gotham db"}>{title}</ActiveTitle>
      ) : (
        <Title className={`black-60 gotham db`}>{title}</Title>
      )}
    </BreadcrumbLink>
  )
}

export default Breadcrumb
